export function evokeByLocation(uri) {
    // @ts-ignore
    window.top.location.href = uri;
}
var iframe;
export function evokeByIFrame(uri) {
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.src = uri;
        iframe.style.cssText = 'display:none;border:0;width:0;height:0;';
        document.body.appendChild(iframe);
        iframe.remove();
        iframe = undefined;
    }
}
export function evokeByTagA(uri) {
    var tagA = document.createElement('a');
    tagA.setAttribute('href', uri);
    tagA.style.display = 'none';
    // append 在 android 6 系统中有兼容性问题
    // eslint-disable-next-line unicorn/prefer-node-append
    document.body.appendChild(tagA);
    tagA.click();
    // tagA.remove();
}
/**
 * 判断页面是否隐藏（进入后台）
 */
export function checkOpen(failure, timeout) {
    var hasApp = false;
    var handler = function () {
        hasApp = true;
        document.removeEventListener('visibilitychange', handler);
    };
    // TIP：兼容处理
    document.addEventListener('visibilitychange', handler);
    setTimeout(function () {
        if (!hasApp)
            failure();
    }, timeout);
}
